export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '正版高清资源',
      description: '全部内容均为正版授权，支持4K超高清画质播放，给您最清晰的观影体验。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速播放',
      description: '全球CDN加速节点覆盖，秒开即播，告别卡顿和缓冲等待。',
    },
    {
      icon: 'ri-lock-line',
      title: '安全稳定',
      description: '多重安全防护机制，保障您的账号安全和隐私数据，让观影无忧。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      description: 'PC、手机、平板多端适配，无缝切换设备，随时随地继续观看。',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            为什么选择91片
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            我们用实力和口碑，为您提供最好的观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, index) => (
            <div key={index} className="text-center p-6 rounded-lg bg-background-50">
              <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-100 mb-4">
                <i className={`${feat.icon} text-primary-500 text-xl md:text-2xl`} />
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}